import { render } from "./eduDownload.vue?vue&type=template&id=73ce5b36&scoped=true"
import script from "./eduDownload.vue?vue&type=script&lang=js"
export * from "./eduDownload.vue?vue&type=script&lang=js"

import "./eduDownload.vue?vue&type=style&index=0&id=73ce5b36&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ce5b36"]])

export default __exports__